import type { ReactNode } from "react";
import { ContentContainer } from "./ContentContainer";
import { Header } from "./Header";

interface LeftPanelProps {
  children: ReactNode;
  progress?: {
    currentStep: number;
    totalSteps: number;
  };
  title?: ReactNode;
  subtitle?: ReactNode;
}

const PADDING = {
  mobile: "px-4 py-4",
  tablet: "md:px-12 md:py-8",
  desktop: "lg:px-12 lg:py-8",
};

export const LeftPanel = ({
  children,
  progress,
  title,
  subtitle,
}: LeftPanelProps) => (
  <div
    className={[
      "animate-fade-in-slow flex w-full flex-col bg-white lg:w-[45%]",
      ...Object.values(PADDING),
    ].join(" ")}
  >
    <div className="flex flex-col">
      <Header progress={progress} />
      <ContentContainer title={title} subtitle={subtitle}>
        {children}
      </ContentContainer>
    </div>
  </div>
);
